import gql from 'graphql-tag';
// (id: $id)
export const GET_SHOOTING_PROGRAM_TEMPLATE_QUERY = gql`
  query getShootingProgramTemplate($id: UUID) {
    getShootingProgramTemplate(id: $id) {
      id
      version
      released
      preApprove
      name {
        value
        languages {
          value
          language
        }
      }
      defaultValues {
        language
        profileName {
          value
          languages {
            value
            language
          }
        }
      }
      executionMode
      tagGroups {
        id
        tags {
          id
        }
      }
      selectionEntry {
        categories {
          id
          values {
            id
          }
        }
        eventTemplates {
          id
          series {
            id
          }
        }
      }
      defaultProfileName {
        value
        languages {
          value
          language
        }
      }
      profiles {
        id
        name {
          value
          languages {
            value
            language
          }
        }
        categories {
          id
          values {
            id
          }
        }
      }
      series {
        id
        type
        marking {
          type
          client
        }
        name {
          defaultValue {
            value
            languages {
              value
              language
            }
          }
          profileValues {
            value {
              value
              languages {
                value
                language
              }
            }
            id
          }
        }
        allowedActions
        reshootingRules
        reshootingProcedureProfile
        targetScale {
          enabled
          nominalDistance
          actualDistance
        }
        teamShootingSetup {
          multipleShooters
          enableSighters
        }
        shots {
          count
        }
        eventTemplates {
          id
          series {
            id
            shots {
              from
              to
            }
          }
        }
        targetScoringDefinition {
          id
          subTargetIndex
          scoringConvert {
            id
            name
            hitZoneConvert {
              id
              name
              from {
                text
                value
              }
              to {
                text
                value
              }
            }
          }
        }
        procedures {
          id
          executionCount
          procedureSteps {
            id
            start
            callouts {
              audioTemplateId {
                defaultValue
                profileValues {
                  value
                  id
                }
              }
              execution {
                mode
                time {
                  defaultValue
                  profileValues {
                    value
                    id
                  }
                }
                waitUntilFinished
                executionTimingMode
              }
              media {
                mediaType
                mediaFormat
                client
                mediaTemplateId {
                  defaultValue
                }
                mediaData {
                  defaultValue
                }
              }
            }
            time {
              from {
                defaultValue
                profileValues {
                  value
                  id
                }
              }
              to {
                defaultValue
                profileValues {
                  value
                  id
                }
              }
              mode
            }
            scoringStateControl {
              repeatCount
              sequences {
                validTargets
                proceedCondition {
                  type
                  duration
                }
              }
            }
          }
        }
        targetLiftPosition {
          position {
            defaultValue
            profileValues {
              value
              id
            }
          }
          shots {
            from
            to
          }
        }
        approval {
          criteria {
            hitCount
            hitFactor
            validZones {
              id
            }
          }
        }
      }
      sumSequences {
        id
        name {
          defaultValue {
            value
            languages {
              value
              language
            }
          }
          profileValues {
            value {
              value
              languages {
                value
                language
              }
            }
            id
          }
        }
        sumIds
      }
      sums {
        id
        innerHitCount
        name {
          defaultValue {
            value
            languages {
              value
              language
            }
          }
          profileValues {
            value {
              value
              languages {
                value
                language
              }
            }
            id
          }
        }
        numberOfDecimals
        scoreType
        series {
          id
          shots {
            from
            to
          }
        }
        type
        ingoingSumId
      }
      calloutConfig {
        audioCollectionId
        defaultAudioProfileId
        mediaCollectionId
        defaultMediaProfileId
        manualStopMediaTemplateId
      }
      enableTeamShooting
      requiredTargetCount
      nominalNumberOfTeamMembers
      executionGroups {
        id
        name
        series
      }
    }
  }
`;

export const GET_SHOOTING_PROGRAM_TEMPLATE_BASIC_INFO_QUERY = gql`
  query getShootingProgramTemplateSummary {
    getShootingProgramTemplateSummary {
      id
      version
      released
      name {
        value
        languages {
          value
          language
        }
      }
    }
  }
`;

export const GET_MEDIA_FILES_QUERY = gql`
  query getMediaFiles($id: UUID) {
    getMediaFiles(id: $id) {
      id
      file
      jsonData {
        name
        mediaType
        mediaFormat
        description
        organizationId
        owner {
          level
        }
        tags
        version
      }
    }
  }
`;

export const GET_MEDIA_FILES_BY_COLLECTION_RELEASE_QUERY = gql`
  query getMediaFilesByCollectionRelease($id: UUID) {
    getMediaFilesByCollectionRelease(id: $id) {
      id
      file
      jsonData {
        name
        mediaType
        mediaFormat
        description
        organizationId
        owner {
          level
        }
        tags
        version
      }
    }
  }
`;
export const GET_MEDIA_COLLECTION_QUERY = gql`
  query getMediaCollections($id: UUID) {
    getMediaCollections(id: $id) {
      id
      name
      released
      mediaTemplates {
        id
        name
      }
      mediaProfiles {
        id
        name
        media {
          mediaTemplateId
          mediaFileId
        }
      }
      version
    }
  }
`;

export const GET_AUDIO_FILES_QUERY = gql`
  query getAudioFiles($id: UUID) {
    getAudioFiles(id: $id) {
      id
      file
      jsonData {
        name
        description
        organizationId
        owner {
          level
        }
        tags
        version
      }
    }
  }
`;

export const GET_AUDIO_COLLECTION_QUERY = gql`
  query getAudioCollections($id: UUID) {
    getAudioCollections(id: $id) {
      id
      jsonData {
        audioCollection {
          name
          released
        }
        version
      }
    }
  }
`;

export const GET_AUDIO_COLLECTION_FULL_QUERY = gql`
  query getAudioCollections($id: UUID) {
    getAudioCollections(id: $id) {
      id
      jsonData {
        audioCollection {
          id
          released
          name
          audioTemplates {
            id
            name
          }
          audioProfiles {
            id
            name
            sounds {
              audioTemplateId
              audioFileId
            }
          }
        }
        version
      }
    }
  }
`;

export const GET_AUDIO_COLLECTION_RELEASE_QUERY = gql`
  query getAudioCollectionRelease($id: UUID!) {
    getAudioCollectionRelease(id: $id) {
      id
      versionMajor
      versionMinor
      versionPatch
      versionPrerelease
      versionPrereleaseNumber
      dateTime
    }
  }
`;

export const GET_MEDIA_COLLECTION_RELEASE_FILTER_QUERY = gql`
  query getMediaCollectionReleaseByFilter($id: UUID!, $limit: Int) {
    getMediaCollectionReleaseByFilter(mediaCollectionId: $id, limit: $limit) {
      id
      mediaCollection {
        id
        version
        name
        mediaTemplates {
          id
          name
        }
        mediaProfiles {
          id
          name
          media {
            mediaTemplateId
            mediaFileId
          }
        }
      }
      versionMajor
      versionMinor
      versionPatch
      versionPrerelease
      versionPrereleaseNumber
      dateTime
      publicationStatus
    }
  }
`;

export const GET_AUDIO_COLLECTION_RELEASE_FILTER_QUERY = gql`
  query getShootingProgramTemplateReleaseByFilter($id: UUID!, $limit: Int) {
    getAudioCollectionReleaseByFilter(audioCollectionId: $id, limit: $limit) {
      id
      versionMajor
      versionMinor
      versionPatch
      versionPrerelease
      versionPrereleaseNumber
      dateTime
    }
  }
`;

export const GET_SHOOTING_PROGRAM_TEMPLATE_RELEASE_FILTER_QUERY = gql`
  query getShootingProgramTemplateReleaseByFilter(
    $id: UUID!
    $filter: String!
    $limit: Int
  ) {
    getShootingProgramTemplateReleaseByFilter(
      shootingProgramTemplateId: $id
      versionFilter: $filter
      limit: $limit
    ) {
      id
      versionMajor
      versionMinor
      versionPatch
      versionPrerelease
      versionPrereleaseNumber
      binaryFileUuid
      dateTime
      publicationStatus
    }
  }
`;

export const GENERATE_SHOOTING_PROGRAM_TEMPLATE_RELEASE = gql`
  mutation generateShootingProgramTemplateRelease(
    $shootingProgramTemplateId: UUID!
    $increaseVersion: SemVerIncreaseType
  ) {
    generateShootingProgramTemplateRelease(
      shootingProgramTemplateId: $shootingProgramTemplateId
      increaseVersion: $increaseVersion
    ) {
      id
    }
  }
`;

export const GENERATE_AUDIO_COLLECTION_RELEASE = gql`
  mutation generateAudioCollectionRelease(
    $audioCollectionId: UUID!
    $increaseVersion: SemVerIncreaseType
  ) {
    generateAudioCollectionRelease(
      audioCollectionId: $audioCollectionId
      increaseVersion: $increaseVersion
    ) {
      id
    }
  }
`;

export const GENERATE_MEDIA_COLLECTION_RELEASE = gql`
  mutation generateMediaCollectionRelease(
    $mediaCollectionId: UUID!
    $increaseVersion: SemVerIncreaseType
  ) {
    generateMediaCollectionRelease(
      mediaCollectionId: $mediaCollectionId
      increaseVersion: $increaseVersion
    ) {
      id
    }
  }
`;

export const ADD_OR_UPDATE_AUDIO_FILES = gql`
  mutation addOrUpdateAudioFile($id: UUID, $audioFile: AudioFileInput!) {
    addOrUpdateAudioFile(id: $id, audioFile: $audioFile) {
      id
    }
  }
`;

export const ADD_OR_UPDATE_MEDIA_FILES = gql`
  mutation addOrUpdateMediaFile($id: UUID, $mediaFile: MediaFileInput!) {
    addOrUpdateMediaFile(id: $id, mediaFile: $mediaFile) {
      id
    }
  }
`;

export const DELETE_AUDIO_FILES = gql`
  mutation deleteAudioFile($id: UUID!) {
    deleteAudioFile(id: $id)
  }
`;

export const DELETE_MEDIA_FILES = gql`
  mutation deleteMediaFile($id: UUID!) {
    deleteMediaFile(id: $id)
  }
`;

export const DELETE_MEDIA_COLLECTION = gql`
  mutation deleteMediaCollection($id: UUID!) {
    deleteMediaCollection(id: $id)
  }
`;

export const DELETE_AUDIO_COLLECTION = gql`
  mutation deleteAudioCollection($id: UUID!) {
    deleteAudioCollection(id: $id)
  }
`;

export const DELETE_AUDIO_COLLECTION_RELEASE = gql`
  mutation deleteAudioCollectionRelease($id: UUID!) {
    deleteAudioCollectionRelease(id: $id)
  }
`;

export const DELETE_MEDIA_COLLECTION_RELEASE = gql`
  mutation deleteMediaCollectionRelease($id: UUID!) {
    deleteMediaCollectionRelease(id: $id)
  }
`;
export const ADD_OR_UPDATE_SHOOTING_PROGRAM_TEMPLATE = gql`
  mutation addOrUpdateShootingProgramTemplate(
    $shootingProgramTemplate: ShootingProgramTemplateInput!
  ) {
    addOrUpdateShootingProgramTemplate(
      shootingProgramTemplate: $shootingProgramTemplate
    ) {
      id
    }
  }
`;

export const UPDATE_SHOOTING_PROGRAM_RELEASE_TYPE = gql`
  mutation updateShootingProgramReleased($id: UUID!) {
    updateShootingProgramReleased(id: $id) {
      id
    }
  }
`;

export const ADD_OR_UPDATE_AUDIO_COLLECTIONS_JSON = gql`
  mutation addOrUpdateAudioCollectionJson(
    $id: UUID
    $audioCollectionJson: String!
  ) {
    addOrUpdateAudioCollectionJson(
      id: $id
      audioCollectionJson: $audioCollectionJson
    ) {
      id
    }
  }
`;

export const ADD_OR_UPDATE_MEDIA_COLLECTIONS_JSON = gql`
  mutation addOrUpdateMediaCollectionJson(
    $id: UUID
    $mediaCollectionJson: String!
  ) {
    addOrUpdateMediaCollectionJson(
      id: $id
      mediaCollectionJson: $mediaCollectionJson
    ) {
      id
    }
  }
`;

export const COPY_SHOOTING_PROGRAM_TEMPLATE = gql`
  mutation copyShootingProgramTemplate($id: UUID!) {
    copyShootingProgramTemplate(id: $id) {
      id
    }
  }
`;

export const DELETE_SHOOTING_PROGRAM_TEMPLATE = gql`
  mutation deleteShootingProgramTemplate($id: UUID!) {
    deleteShootingProgramTemplate(id: $id)
  }
`;

export const DELETE_SHOOTING_PROGRAM_TEMPLATE_RELEASE = gql`
  mutation deleteShootingProgramTemplateRelease($id: UUID!) {
    deleteShootingProgramTemplateRelease(id: $id)
  }
`;

export const GET_REGISTERED_ACTION_TYPES = gql`
  query {
    getRegistreredActionTypes
  }
`;

export const GET_REGISTERED_RESHOOTING_RULES = gql`
  query {
    getReshootingRules
  }
`;

export const GET_REGISTERED_RESHOOTING_PROCEDURE_PROFILES = gql`
  query {
    getReshootingProcedureProfiles
  }
`;

export const UPDATE_SHOOTING_PROGRAM_TEMPLATE_RELEASE_PUBLICATION_STATUS = gql`
  mutation updateShootingProgramTemplateReleasePublicationStatus(
    $id: UUID!
    $publicationStatus: PublicationStatus!
  ) {
    updateShootingProgramTemplateReleasePublicationStatus(
      id: $id
      publicationStatus: $publicationStatus
    ) {
      id
    }
  }
`;

export const UPDATE_MEDIA_COLLECTION_RELEASE_PUBLICATION_STATUS = gql`
  mutation updateMediaCollectionReleasePublicationStatus(
    $id: UUID!
    $publicationStatus: PublicationStatus!
  ) {
    updateMediaCollectionReleasePublicationStatus(
      id: $id
      publicationStatus: $publicationStatus
    ) {
      id
    }
  }
`;
